module.exports = __webpack_public_path__ + "img/cloud3.59a18a45.png";